import React from 'react';
import PropTypes from 'prop-types';

import Definition from '../../../shared/Definition';
import { TrainerLink } from '../../../shared/links/ProfileLink';

const Trainer = ({
    hasPedigree,
    trainerName,
    trainerUid,
    trainerLast14Days: {
        wins,
        runs,
        percent,
    },
}) => (
    trainerUid ? (
        <Definition term="Trainer">
            <TrainerLink
                trainerStyleName={trainerName}
                trainerUid={trainerUid}
            />
            {!hasPedigree && !!runs && (
                <span className="hp-details__info">
                    &nbsp;(Last 14 days: {wins}-{runs}, {percent}%)
                </span>
            )}
        </Definition>
    ) : null
);

Trainer.propTypes = {
    hasPedigree: PropTypes.bool,
    trainerName: PropTypes.string,
    trainerUid: PropTypes.number,
    trainerLast14Days: PropTypes.shape({
        wins: PropTypes.number,
        runs: PropTypes.number,
        percent: PropTypes.number,
    }),
};

export default Trainer;



// WEBPACK FOOTER //
// ./src/js/horse/details/components/Trainer.jsx